import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Role } from "@/store";
import { requireRoles } from "@/utils/requiredRoles";

export const Route = createFileRoute("/_private/dashboard/_base/transportadoras/_forms/editar/$id")({
  component: Outlet,
  params: {
    parse: (val) => ({ id: +val.id })
  },
  beforeLoad: requireRoles({ notAllowed: [Role.Usuario] })
});
